export const FETCH_USERS = "FETCH_USERS"
export const FETCH_USERS_FAIL = "FETCH_USERS_FAIL"
export const FETCH_USER = "FETCH_USER"
export const FETCH_USER_FAIL = "FETCH_USER_FAIL"
export const EDIT_USER = "EDIT_USER"
export const POST_USER = "POST_USER"
export const POST_USER_FAIL = "POST_USER_FAIL"
export const EDIT_USER_FAIL = "EDIT_USER_FAIL"
export const SET_FAIL_MESSAGE_USER = "SET_FAIL_MESSAGE"
export const FETCH_CURRENT_USER = "FETCH_CURRENT_USER"
export const FETCH_CURRENT_USER_FAIL = "FETCH_CURRENT_USER_FAIL"
export const EDIT_CURRENT_USER = "EDIT_CURRENT_USER"
export const EDIT_CURRENT_USER_FAIL = "EDIT_CURRENT_USER_FAIL"
export const DELETE_CURRENT_USER = "DELETE_CURRENT_USER"
export const DELETE_CURRENT_USER_FAIL = "DELETE_CURRENT_USER_FAIL"
export const DELETE_USER = "DELETE_USER"
export const DELETE_USER_FAIL = "DELETE_USER_FAIL"
export const CLEAR_USER = "CLEAR_USER"
export const LOADING_USERS = "LOADING_USERS"
export const CLEAR_USERS = "CLEAR_USERS"
export const CURRENT_USER_IS_LOADING = "CURRENT_USER_IS_LOADING"